<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="7"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="custom-header-title float-left pr-1 mb-0">
              Retail Coupons
            </h2>
          </b-col>
        </b-row>
      </b-col>

      <!-- Content Right -->
      <b-col
        class="content-header-right text-right mb-1"
        md="3"
        cols="5"
      >
        <b-button
          v-if="canViewThisAction('create', 'RetailCoupon')"
          variant="success"
          class="mobile_create_button"
          :to="{ name: 'products-retail-coupons-create' }"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
            size="16"
          />
          <span class="align-middle d-md-block d-none">Create new Coupon</span>
          <span class="align-middle d-md-none d-block">New</span>
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mb-1">
      <b-col cols="12">
        <b-button
          v-for="tab in statusTabs"
          :key="tab.code"
          :variant="activeTab === tab.code ? 'primary' : 'outline-primary'"
          class="status-tab-button mr-1 mb-1"
          @click="activeTab = tab.code"
        >
          {{ tab.title }} <b-badge
            pill
            :variant="activeTab === tab.code ? 'light' : 'light-primary'"
            :class="{ 'active-tab-badge': activeTab === tab.code }"
            class="ml-50"
          >
            {{ tab.count }}
          </b-badge>
        </b-button>
      </b-col>
    </b-row>

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-dropdown
              v-if="canViewThisAction('delete', 'RetailCoupon')"
              variant="primary"
              text="Bulk actions"
            >
              <b-dropdown-item>
                Delete selected
              </b-dropdown-item>
            </b-dropdown>
            <span class="text-muted ml-1">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-coupon-filter"
                ref="filter_dropdown_coupons"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <retail-coupon-filter
                  :active-tab="activeTab"
                  :value-type.sync="valueTypeFilter"
                  :value-type-options="valueTypeOptions"
                  :status.sync="statusFilter"
                  :status-options="statusFilterOptions"
                  @emitHideFilter="hideFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="valueTypeFilter.length || statusFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul class="list-inline d-inline-block mb-1">
                <li
                  v-for="item in statusFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromStatusFilter(item)"
                  >
                    <span class="text-capitalize">{{ item }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="item in valueTypeFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromValueTypeFilter(item)"
                  >
                    <span class="text-capitalize">{{ item }}</span>
                  </b-form-tag>
                </li>
                <li class="list-inline-item">
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        class="position-relative min-height-table"
        :items="paginatedCoupons"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        show-empty
        empty-text="No matching coupons found"
      >
        <template #head(checkbox)>
          <b-form-checkbox />
        </template>
        <template #cell(checkbox)>
          <b-form-checkbox />
        </template>

        <template #cell(id)="data">
          <b-link
            class="weight-600 align-middle detail-view-id"
            :to="{ name: 'products-retail-coupons-show', params: { id: data.item._id } }"
          >
            {{ data.item.stringID }}
          </b-link>
        </template>

        <template #cell(couponCode)="data">
          <b-link
            class="weight-600 align-middle detail-view-id"
            :to="{ name: 'products-retail-coupons-show', params: { id: data.item._id } }"
          >
            {{ data.item.couponCode }}
          </b-link>
        </template>

        <template #cell(value)="data">
          <span v-if="data.item.valueType === 'Percentage'">{{ data.item.value }}%</span>
          <span v-else-if="data.item.valueType === 'Dollar'">S${{ numberFormat(data.item.value) }}</span>
        </template>

        <template #cell(availablePeriod)="data">
          {{ data.item.usableFrom ? dateFormat(data.item.usableFrom) : 'Anytime' }} – {{ data.item.usableUntil ? dateFormat(data.item.usableUntil) : 'Forever' }}
        </template>

        <template #cell(quotaLeft)="data">
          {{ data.item.totalQuota != null ? Math.max(data.item.totalQuota - data.item.usedQuota, 0) : 'No limit' }}
        </template>

        <template #cell(createdDate)="data">
          {{ data.item.createdBy ? data.item.createdBy.name : '-' }}<br>
          <span class="text-muted">{{ dateFormatWithTime(data.item.createdAt) }}</span>
        </template>

        <template #cell(status)="data">
          <b-badge
            :variant="`light-${data.item.status === 'Active' ? 'success' : 'secondary'}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="canViewThisAction('update', 'RetailCoupon')"
              :to="{ name: 'products-retail-coupons-edit', params: { id: data.item._id } }"
            >
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('delete', 'RetailCoupon')"
              @click="deleteCoupon(data.item._id)"
            >
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-card>

    <div
      v-if="filteredCoupons.length > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="filteredCoupons.length"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BCard, BTable, BBadge, BDropdown, BDropdownItem, BFormCheckbox, BLink,
  BFormInput, BInputGroup, BInputGroupAppend, BFormTag, BPagination,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import RetailCouponFilter from './RetailCouponFilter.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BLink,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormTag,
    BPagination,
    RetailCouponFilter,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },

  directives: {
    Ripple,
  },

  data() {
    return {
      canViewThisAction,
      activeTab: 'All',
      showSearchBar: false,
      searchQuery: '',
      valueTypeFilter: [],
      valueTypeOptions: [
        { title: 'Percentage', code: 'Percentage' },
        { title: 'Dollar', code: 'Dollar' },
      ],
      statusFilter: [],
      statusFilterOptions: [
        { title: 'Active', code: 'Active' },
        { title: 'Inactive', code: 'Inactive' },
      ],
      tableColumns: [
        { key: 'checkbox', label: '' },
        { key: 'id', label: 'ID' },
        { key: 'couponCode', label: 'Coupon Code', sortable: true },
        { key: 'couponTitle', label: 'Coupon Title', sortable: true },
        { key: 'value', label: 'Value', sortable: true },
        { key: 'availablePeriod', label: 'Available Period', sortable: true },
        { key: 'quotaPerUser', label: 'Quota Per User', sortable: true },
        { key: 'totalQuota', label: 'Total Quota', sortable: true },
        { key: 'quotaLeft', label: 'Quota Left', sortable: true },
        { key: 'createdDate', label: 'Created Date' },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
      coupons: [],
      currentPage: 1,
      perPage: Number(process.env.VUE_APP_PER_PAGE_CONTENT) || 10,
    }
  },

  computed: {
    statusTabs() {
      return [
        { title: 'Active', code: 'Active', count: this.coupons.filter(c => c.status === 'Active').length },
        { title: 'Inactive', code: 'Inactive', count: this.coupons.filter(c => c.status === 'Inactive').length },
        { title: 'All Coupons', code: 'All', count: this.coupons.length },
      ]
    },
    filteredCoupons() {
      let list = this.coupons

      if (this.activeTab !== 'All') {
        list = list.filter(c => c.status === this.activeTab)
      }

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase()
        list = list.filter(c => c.couponCode.toLowerCase().includes(query) || c.couponTitle.toLowerCase().includes(query))
      }

      if (this.valueTypeFilter.length) {
        list = list.filter(c => this.valueTypeFilter.includes(c.valueType))
      }

      if (this.statusFilter.length) {
        list = list.filter(c => this.statusFilter.includes(c.status))
      }

      return list
    },
    paginatedCoupons() {
      const start = (this.currentPage - 1) * this.perPage
      return this.filteredCoupons.slice(start, start + this.perPage)
    },
    dataMeta() {
      const total = this.filteredCoupons.length
      const localCount = this.paginatedCoupons.length
      return {
        from: this.perPage * (this.currentPage - 1) + (localCount ? 1 : 0),
        to: this.perPage * (this.currentPage - 1) + localCount,
        of: total,
      }
    },
  },

  watch: {
    activeTab() {
      this.currentPage = 1
    },
    searchQuery() {
      this.currentPage = 1
    },
    valueTypeFilter() {
      this.currentPage = 1
    },
    statusFilter() {
      this.currentPage = 1
    },
  },

  mounted() {
    this.fetchRetailCoupons()
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_coupons.hide(true)
    },
    removeFromValueTypeFilter(item) {
      const index = this.valueTypeFilter.indexOf(item)
      if (index > -1) {
        this.valueTypeFilter.splice(index, 1)
      }
    },
    removeFromStatusFilter(item) {
      const index = this.statusFilter.indexOf(item)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },
    clearAllFilters() {
      this.valueTypeFilter = []
      this.statusFilter = []
    },
    fetchRetailCoupons() {
      this.$http.get('products/retail-coupons', { params: { perPage: 1000 } })
        .then(response => {
          this.coupons = response.data.retailCoupons
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    deleteCoupon(id) {
      this.$swal({
        title: 'Warning!',
        text: ' Are you sure you want to delete this?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete!',
        cancelButtonText: 'No, Cancel',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.$http.delete(`products/retail-coupons/${id}/delete`)
              .then(response => {
                this.fetchRetailCoupons()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: response.data.message ?? '',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.status-tab-button {
  &.btn-outline-primary {
    border-color: #104D9D;
    color: #104D9D;
  }
  &.btn-primary {
    color: #FFFFFF;
  }
}

.active-tab-badge {
  background-color: #FFFFFF;
  color: #104D9D;
}
</style>
